export default __webpack_public_path__ + "static/media/bannerBg.f23a9c9b.png";